import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { Comments } from '@/components/Post/components/Comments';
import {
  CreateComment,
  CreateComment_postFragment,
} from '@/components/Post/components/CreateComment';
import { useCommentActions } from '@/components/Post/hooks/useCommentActions';
import { Card } from '@/imports/ui/chakra/components/Card';

import { AnswerDetail_AnswerV2Fragment } from './graphql-types/AnswerDetail_AnswerV2Fragment';

import { AnswerContent } from '../../components/AnswerContent';

export const AnswerDetail: React.FC<{
  answer: AnswerDetail_AnswerV2Fragment;
}> & {
  answerFragment: DocumentNode;
} = ({ answer }) => {
  const {
    ref,
    focusAndScrollToRef,
    expandOrFocusAndScrollToRef,
    isActive,
    setIsActive,
    ...expandProps
  } = useCommentActions({
    post: answer,
  });

  return (
    <Card width="full">
      <AnswerContent
        answer={answer}
        onClickComment={focusAndScrollToRef}
        onClickCommentCount={expandOrFocusAndScrollToRef}
      >
        <Comments post={answer} expandProps={expandProps} />
        <CreateComment
          post={answer}
          ref={ref}
          isActive={isActive}
          setIsActive={setIsActive}
        />
        /
      </AnswerContent>
    </Card>
  );
};

AnswerDetail.answerFragment = gql`
  fragment AnswerDetail_AnswerV2Fragment on AnswerV2 {
    _id
    ...AnswerContent_AnswerV2Fragment
    ...Comments_PostFragment
    ...CreateComment_PostFragment
    ...useCommentActions_PostFragment
  }
  ${AnswerContent.answerFragment}
  ${Comments.postFragment}
  ${CreateComment_postFragment}
  ${useCommentActions.postFragment}
`;
